"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("@alcumus/components");
const look_1 = require("../../../server/models/look");
const dashboard_1 = require("../../../server/models/dashboard");
const ReportBasePage_1 = __importDefault(require("../BasePage/ReportBasePage"));
const FavoriteRoute_1 = __importDefault(require("../../../routes/FavoriteRoute"));
const EmptyState_1 = __importDefault(require("../EmptyState/EmptyState"));
const FavoriteReportsPage = ({ t, tReady, }) => {
    const headers = [
        { id: 'icon', displayName: '' },
        { id: 'name', displayName: t('name', { ns: 'TableHeaders' }) },
        {
            id: 'viewCount',
            displayName: t('views', { ns: 'TableHeaders' }),
            isNumeric: true,
        },
        { id: 'createdBy', displayName: t('owner', { ns: 'TableHeaders' }) },
        { id: 'folder', displayName: t('folder', { ns: 'TableHeaders' }) },
        {
            id: 'contentFavoriteId',
            displayName: t('favorite', { ns: 'TableHeaders' }),
        },
    ];
    const emptyState = (react_1.default.createElement(EmptyState_1.default, { dashboardText: t('favoriteDashboardText'), lookText: t('favoriteLookText') }));
    return (react_1.default.createElement(components_1.TranslateReady, { tReady: tReady },
        react_1.default.createElement(ReportBasePage_1.default, { title: FavoriteRoute_1.default.friendlyName, getDashboardsFunction: () => (0, dashboard_1.searchDashboardsAndSync)({ contentFavoriteId: 'not null' }), getLooksFunction: () => (0, look_1.searchLooksAndSync)({ contentFavoriteId: 'not null' }), headers: headers, showViews: true, emptyState: emptyState })));
};
exports.default = (0, react_i18next_1.withTranslation)(['EmptyState', 'TableHeaders'])(FavoriteReportsPage);
